// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"1b695dc9","359":"3809198e","453":"1eb43f1a","551":"7f3e9f5d","623":"2d99e247","760":"c5731cb6","885":"d8b97f75","950":"1ad776d8","965":"02e3d758"}[chunkId] + ".chunk.js";
};